angular.module('impactx.relationView').directive('appClassificationRelationView', [function() {
    return {
        scope: {
            name: '=',
            relation: '=',
            trns: '=',
            readOnly: "=",
            required: "=",
            dialogData: "="
        },
        restrict: 'E',
        templateUrl: 'shared/relation-view/templates/classificationrelation.html',
        controller: "ClassificationRelationViewController",
        controllerAs: "classifRelationController"
    };
}]);